
import { createContext, useContext, ReactNode, useState } from "react";
import { Category } from "@/entities/category.entity";

interface PresetCategoriesContextType {
  categories: Category[] | null;
  setPresetCategories: (categories: Category[] | null) => void;
}

const PresetCategoriesContext = createContext<PresetCategoriesContextType>({
  categories: null,
  setPresetCategories: () => {},
});

export function PresetCategoriesProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [categories, setCategories] = useState<Category[] | null>(null);

  return (
    <PresetCategoriesContext.Provider value={{ categories, setPresetCategories: setCategories }}>
      {children}
    </PresetCategoriesContext.Provider>
  );
}

export function usePresetCategories() {
  return useContext(PresetCategoriesContext);
}
